import DOMPurify from 'dompurify';
import { Marked } from 'marked';

// Links leave the app in a new tab without handing it window.opener.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const escapeHtml = (text: string) =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Raw HTML in the source is shown as text, never rendered.
const marked = new Marked({
  gfm: true,
  breaks: true,
  async: false,
  renderer: { html: ({ text }) => escapeHtml(text) },
});

/** GitHub-flavoured markdown → sanitized HTML. */
export const renderMarkdown = (source: string): string =>
  DOMPurify.sanitize(marked.parse(source) as string, {
    FORBID_TAGS: ['style', 'iframe', 'form', 'input'],
  });

/** Plain-text preview of markdown for one-line summaries (list cards). */
export const stripMarkdown = (source: string): string =>
  source
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/[#*_>`~|-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
